import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getMainTranscriptName,
  getMainTranscriptCodingImpact,
  getMainTranscriptIsCanonical,
} from "../../../../state/selectors/general.selectors";
import { getIfTranscriptsExist } from "../../../../state/selectors/Transcripts.selectors";
import { getEnsemblTranscripts } from "../../../../state/selectors/EnsemblTranscripts.selectors";
import { getRefseqTranscripts } from "../../../../state/selectors/RefseqTranscripts.selectors";
import { getACMGVerdictClassifications } from "../../../../state/selectors/CardsUI.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import style from "./_transcripts.module.scss";
import { getManeTranscriptForACMG } from "../../../../pages/variant/components/transcripts/helpers";

const calculateMane = (transcriptName, refseqTranscripts, ensemblTranscripts) =>
  getManeTranscriptForACMG(
    transcriptName,
    refseqTranscripts?.[0]?.items,
    ensemblTranscripts?.[0]?.items
  );

const TranscriptsCard = ({
  transcriptsExist,
  acmgRules,
  mainTranscript,
  refSeqTranscript,
  ensemblTranscript,
  codingImpact,
  card,
  isMainTranscriptCanonical,
}) => {
  const TranscriptsBackgroundColor = () => {
    const pathogenic = acmgRules.some((acmgRule) =>
      acmgRule.startsWith("PVS1")
    );
    const likelyPathogenic = acmgRules.some((acmgRule) =>
      acmgRule.startsWith("PM4")
    );
    const benign = acmgRules.some((acmgRule) => acmgRule.startsWith("BP7"));
    if (pathogenic) {
      return getPathogenicityColorByAllNames("Pathogenic");
    }
    if (likelyPathogenic) {
      return getPathogenicityColorByAllNames("Likely Pathogenic");
    }
    if (benign) {
      return getPathogenicityColorByAllNames("Benign");
    }
    return getPathogenicityColorByAllNames("Uncertain Significance");
  };

  const isDisabled = !transcriptsExist;
  const isManeTranscript = Boolean(
    calculateMane(mainTranscript, refSeqTranscript, ensemblTranscript)
  );
  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={TranscriptsBackgroundColor()}
    >
      {mainTranscript ? (
        <div>
          <p data-testid="mainTranscript" className={style.detail}>
            {mainTranscript}
            <>
              {" - "}
              <span
                style={{
                  color: TranscriptsBackgroundColor(),
                }}
              >
                {codingImpact ?? "non coding"}
              </span>
            </>
          </p>
          {isManeTranscript && (
            <div className="tw-font-bold">
              {calculateMane(
                mainTranscript,
                refSeqTranscript,
                ensemblTranscript
              ).replace(", ", "")}
            </div>
          )}
          {!isManeTranscript && isMainTranscriptCanonical && (
            <div className="tw-font-bold">Canonical</div>
          )}
        </div>
      ) : null}
    </CardWrapper>
  );
};

TranscriptsCard.propTypes = {
  transcriptsExist: PropTypes.bool,
  acmgRules: PropTypes.arrayOf(PropTypes.string),
  refSeqTranscript: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({})),
      version: PropTypes.string,
    })
  ),
  ensemblTranscript: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({})),
      version: PropTypes.string,
    })
  ),
  mainTranscript: PropTypes.string,
  codingImpact: PropTypes.string,
  card: PropTypes.instanceOf(Card).isRequired,
  isMainTranscriptCanonical: PropTypes.bool,
};

TranscriptsCard.defaultProps = {
  transcriptsExist: false,
  acmgRules: [],
  refSeqTranscript: [],
  ensemblTranscript: [],
  mainTranscript: null,
  codingImpact: null,
  isMainTranscriptCanonical: false,
};

const mapStateToProps = (state) => ({
  transcriptsExist: getIfTranscriptsExist(state),
  acmgRules: getACMGVerdictClassifications(state),
  mainTranscript: getMainTranscriptName(state),
  refSeqTranscript: getRefseqTranscripts(state),
  ensemblTranscript: getEnsemblTranscripts(state),
  codingImpact: getMainTranscriptCodingImpact(state),
  isMainTranscriptCanonical: getMainTranscriptIsCanonical(state),
});

export default connect(mapStateToProps, {})(TranscriptsCard);
